const headerTableFixedCssClass = "table-header-fixed";
const HasHeaderTableFixedCssClass = (table) => table.className.includes(headerTableFixedCssClass);

const SetTbodyColumnWidthInTheadColumn = (tbodyColumn, theadColumn) => {
    for (var i = 0; i < theadColumn.children.length; i++) {
        var widthTbodyColumn = tbodyColumn.children[i].offsetWidth;
        theadColumn.children[i].style.width = `${widthTbodyColumn}px`;
    }
}

//
const HeaderTableFixed = () => {
    /*
    * Será necessário um ID para identifiar a distancia da tabela para o topo da pagina
    * O id tem que estar na duas divs acima da table. De forma que o selector fique assim: #tableHeaderFixed > div > table ou #tableHeaderFixed > BootstrapTable
    * Para funcionar também será necessário adicionar o evento de scroll e chamar esta função
    */

    var table = document.getElementById("tableHeaderFixed");
    if (!table) return;
    var dimensionsTable = table.getBoundingClientRect();

    if (dimensionsTable.top < 12) {
        if (!HasHeaderTableFixedCssClass(table)) {
            table.classList.add(headerTableFixedCssClass);

            var theadColumn = document.querySelector("thead > tr")
            var tbodyColumn = document.querySelector("tbody > tr:nth-child(1)");
            var widthTbody = document.querySelector("tbody").offsetWidth;
            theadColumn.style.width = `${widthTbody}px`;

            SetTbodyColumnWidthInTheadColumn(tbodyColumn, theadColumn);
        }
    }
    else
        table.classList.remove("table-header-fixed");
}

export { HeaderTableFixed }


// WEBPACK FOOTER //
// ./src/utils/headerTableFixed.js